/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const LocalSystemInformationReadSubscription = gql`
  subscription SystemReadSubscription {
    SystemInformationReadData {
      currentLoad
      memory
      fsSize
      serverStatus
    }
  }
`


/*
 * EXPORTS
 */
export default LocalSystemInformationReadSubscription
